module.exports = __webpack_public_path__ + "static/img/sedan-red.3eb9267.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sedan-red.svg
// module id = DwOa
// module chunks = 74